(function () {
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function portalToBody(el) {
    if (el && el.parentNode !== document.body) {
      document.body.appendChild(el);
    }
  }

  function initCollectionsMenu() {
    var btn = qs('[data-collections-trigger]');
    var menu = qs('[data-collections-menu]');
    if (!btn || !menu) return;

    portalToBody(menu);

    function position() {
      var rect = btn.getBoundingClientRect();
      menu.style.top = rect.bottom + 8 + 'px';
      var left = Math.min(rect.left, window.innerWidth - menu.offsetWidth - 12);
      menu.style.left = Math.max(8, left) + 'px';
    }

    function open() {
      position();
      menu.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    }

    function close() {
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (menu.hidden) open();
      else close();
    });

    document.addEventListener('mousedown', function (event) {
      if (menu.hidden) return;
      if (btn.contains(event.target) || menu.contains(event.target)) return;
      close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !menu.hidden) close();
    });

    window.addEventListener('resize', function () {
      if (!menu.hidden) position();
    });
    window.addEventListener(
      'scroll',
      function () {
        if (!menu.hidden) position();
      },
      true
    );
  }

  function getFocusable(root) {
    return qsa(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])',
      root
    ).filter(function (el) {
      return !el.closest('[hidden]');
    });
  }

  function initMobileNav() {
    var openBtn = qs('[data-mobile-nav-open]');
    var drawer = qs('[data-mobile-nav]');
    if (!openBtn || !drawer) return;

    portalToBody(drawer);

    var closeBtns = qsa('[data-mobile-nav-close]', drawer);
    var collectionsToggle = qs('[data-mobile-collections-toggle]', drawer);
    var collectionsPanel = qs('[data-mobile-collections]', drawer);
    var panel = qs('.mobile-nav__panel', drawer);
    var lastFocus = null;
    var scrollY = 0;

    function setBackgroundInert(on) {
      Array.from(document.body.children).forEach(function (el) {
        if (el === drawer) return;
        if (on) el.setAttribute('inert', '');
        else el.removeAttribute('inert');
      });
    }

    function lockScroll() {
      scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.documentElement.classList.add('nav-open');
      document.body.classList.add('nav-open');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.documentElement.classList.remove('nav-open');
      document.body.classList.remove('nav-open');
      window.scrollTo(0, scrollY);
    }

    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      lockScroll();
      setBackgroundInert(true);
      openBtn.setAttribute('aria-expanded', 'true');
      var closeBtn = qs('.mobile-nav__head [data-mobile-nav-close]', drawer);
      var moveFocus = function () {
        if (closeBtn) closeBtn.focus();
        else if (panel) panel.focus();
      };
      if (window.requestAnimationFrame) window.requestAnimationFrame(moveFocus);
      else moveFocus();
    }

    function close() {
      if (drawer.hidden) return;
      drawer.hidden = true;
      setBackgroundInert(false);
      unlockScroll();
      openBtn.setAttribute('aria-expanded', 'false');
      var back = lastFocus && document.contains(lastFocus) ? lastFocus : openBtn;
      if (back && typeof back.focus === 'function') back.focus();
    }

    openBtn.addEventListener('click', open);
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (drawer.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = getFocusable(drawer);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      if (event.shiftKey && (active === first || !drawer.contains(active))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || !drawer.contains(active))) {
        event.preventDefault();
        first.focus();
      }
    });

    if (collectionsToggle && collectionsPanel) {
      collectionsToggle.addEventListener('click', function () {
        var willOpen = collectionsPanel.hidden;
        collectionsPanel.hidden = !willOpen;
        collectionsToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    }

    qsa('a', drawer).forEach(function (link) {
      link.addEventListener('click', close);
    });
  }

  function formatMoney(cents, format) {
    var amount = Number(cents);
    if (!isFinite(amount)) return '';
    var formatString = format || '${{amount}}';

    function formatWith(precision, thousands, decimal) {
      var negative = amount < 0;
      var fixed = (Math.abs(amount) / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var formatted = whole;
      if (precision > 0) formatted += decimal + parts[1];
      return (negative ? '-' : '') + formatted;
    }

    var placeholders = {
      amount: formatWith(2, ',', '.'),
      amount_no_decimals: formatWith(0, ',', '.'),
      amount_with_comma_separator: formatWith(2, '.', ','),
      amount_no_decimals_with_comma_separator: formatWith(0, '.', ','),
      amount_with_apostrophe_separator: formatWith(2, "'", '.'),
      amount_no_decimals_with_space_separator: formatWith(0, ' ', ' '),
      amount_with_space_separator: formatWith(2, ' ', ','),
      amount_with_period_and_space_separator: formatWith(2, ' ', '.')
    };

    return formatString.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_match, key) {
      return Object.prototype.hasOwnProperty.call(placeholders, key) ? placeholders[key] : '';
    });
  }

  function initProductForm() {
    var form = qs('[data-product-form]');
    if (!form) return;

    var root = form.closest('[data-product-root]') || document;
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var variantSelect = qs('[data-variant-select]', form);
    var variantsNode = qs('[data-product-variants]', root);
    var variants = [];

    try {
      if (variantsNode) variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      variants = [];
    }

    function bindPersonalization() {
      var field = qs('[data-personalization]', form);
      var count = qs('[data-personalization-count]', form);
      if (field && count) {
        var updateCount = function () {
          count.textContent = String(field.value.length);
        };
        field.addEventListener('input', updateCount);
        updateCount();
      }

      form.addEventListener('submit', function () {
        if (!field) return;
        field.value = field.value.trim();
        if (count) count.textContent = String(field.value.length);
        if (!field.required && !field.value) field.removeAttribute('name');
      });
    }

    bindPersonalization();

    if (!variantSelect || !variants.length) return;

    var priceCurrent = qs('[data-price-current]', root);
    var priceCompare = qs('[data-price-compare]', root);
    var priceButton = qs('[data-product-price-btn]', form);
    var addButton = qs('[data-add-button]', form);
    var saleBadge = qs('[data-sale-badge]', root);
    var image = document.getElementById('product-image');
    var labelAdd = form.getAttribute('data-label-add') || 'Add to cart';
    var labelSoldOut = form.getAttribute('data-label-sold-out') || 'Sold out';
    var labelUnavailable = form.getAttribute('data-label-unavailable') || 'Unavailable';

    function selectedOptions() {
      var options = [];
      qsa('[data-option-group]', form).forEach(function (group) {
        var selected = qs('[data-option-input]:checked', group);
        options.push(selected ? selected.value : null);
      });
      return options;
    }

    function findVariant(options) {
      return (
        variants.find(function (variant) {
          return (
            Array.isArray(variant.options) &&
            variant.options.length === options.length &&
            variant.options.every(function (option, index) {
              return option === options[index];
            })
          );
        }) || null
      );
    }

    function setButton(variant) {
      if (!addButton) return;
      addButton.replaceChildren();
      if (variant && variant.available) {
        addButton.disabled = false;
        addButton.append(document.createTextNode(labelAdd + ' — '));
        var price = document.createElement('span');
        price.setAttribute('data-product-price-btn', '');
        price.textContent = formatMoney(variant.price, moneyFormat);
        addButton.append(price);
        priceButton = price;
        return;
      }
      addButton.disabled = true;
      addButton.textContent = variant ? labelSoldOut : labelUnavailable;
      priceButton = null;
    }

    function updateOptionAvailability(options) {
      qsa('[data-option-group]', form).forEach(function (group) {
        var index = Number(group.getAttribute('data-option-index'));
        qsa('[data-option-input]', group).forEach(function (input) {
          var label = qs('label[for="' + input.id + '"]', group);
          var possible = variants.some(function (variant) {
            if (!variant.available || !Array.isArray(variant.options)) return false;
            return variant.options.every(function (option, optionIndex) {
              if (optionIndex === index) return option === input.value;
              if (options[optionIndex] == null) return true;
              return option === options[optionIndex];
            });
          });
          if (label) label.classList.toggle('is-unavailable', !possible);
        });
      });
    }

    function syncRadios(variant) {
      if (!variant || !Array.isArray(variant.options)) return;
      qsa('[data-option-group]', form).forEach(function (group, index) {
        qsa('[data-option-input]', group).forEach(function (input) {
          input.checked = input.value === variant.options[index];
        });
      });
    }

    function applyVariant(variant, updateUrl) {
      if (variantSelect) {
        if (variant) {
          variantSelect.disabled = false;
          variantSelect.value = String(variant.id);
        } else {
          variantSelect.disabled = true;
        }
      }

      if (variant && priceCurrent) priceCurrent.textContent = formatMoney(variant.price, moneyFormat);
      if (priceCompare) {
        var onSale = variant && variant.compare_at_price > variant.price;
        priceCompare.hidden = !onSale;
        priceCompare.textContent = onSale ? formatMoney(variant.compare_at_price, moneyFormat) : '';
      }
      if (saleBadge) saleBadge.hidden = !(variant && variant.compare_at_price > variant.price);
      if (priceButton && variant && variant.available) {
        priceButton.textContent = formatMoney(variant.price, moneyFormat);
      }

      setButton(variant);
      updateOptionAvailability(variant ? variant.options : selectedOptions());

      if (image && variant && variant.image) {
        image.src = variant.image;
        image.removeAttribute('srcset');
      }

      if (updateUrl && variant && variant.url) {
        window.history.replaceState({}, '', variant.url);
      }
    }

    form.classList.add('is-enhanced');
    var fallback = qs('[data-variant-fallback]', form);
    if (fallback) fallback.setAttribute('aria-hidden', 'true');
    variantSelect.tabIndex = -1;

    qsa('[data-option-input]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        var options = selectedOptions();
        applyVariant(findVariant(options), true);
      });
    });

    variantSelect.addEventListener('change', function () {
      var variant = variants.find(function (item) {
        return String(item.id) === variantSelect.value;
      });
      if (variant) syncRadios(variant);
      applyVariant(variant || null, true);
    });

    updateOptionAvailability(selectedOptions());
  }

  function init() {
    initCollectionsMenu();
    initMobileNav();
    initProductForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
